import { PublicClientApplication } from '@azure/msal-browser';

const azureClientId =
  import.meta.env.VITE_AZURE_CLIENT_ID ||
  '51bc9166-9c68-47c2-a948-6a08370227ca';
const redirectUri =
  import.meta.env.VITE_REDIRECT_URI || 'http://localhost:4200/map';

// Check if we're in a secure context (HTTPS), localhost is considered secure
const isHttps =
  window.location.protocol === 'https:' ||
  window.location.hostname === 'localhost';

export const msalConfig = {
  auth: {
    clientId: azureClientId,
    authority: 'https://login.microsoftonline.com/common',
    redirectUri: redirectUri,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    allowNativeBroker: false,
    // cryptoOptions: {
    //   // Only use basic cryptography in non-HTTPS environments
    //   libraryName: isHttps ? undefined : 'msCrypto',
    //   useMsrCrypto: !isHttps,
    // },
  },
};

export const msalInstance = isHttps
  ? new PublicClientApplication(msalConfig)
  : null;

export const loginRequest = {
  scopes: ['User.Read'],
};
